import React from 'react';
import { FadeIn, Section, SectionLabel, ButtonSecondary, ButtonPrimary } from './UI';
export const OfferSection = () => {
  const checkoutUrl = 'https://shop.beacons.ai/inkovacreation/0de4a31b-dafb-4911-b0f5-64f146eb7e48';
  return <>
      <Section id="cta" className="bg-brand-grayBg" data-id="element-38">
        <FadeIn data-id="element-39">
          <SectionLabel data-id="element-40">Lo que obtienes hoy</SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-brand-dark mb-5 font-bold" data-id="element-41">
            Todo incluido.
            <br data-id="element-42" />
            <span className="text-brand-purple" data-id="element-43">Un solo precio.</span>
          </h2>

          <div className="overflow-x-auto mt-7 mb-7" data-id="element-44">
            <table className="w-full border-collapse" data-id="element-45">
              <thead data-id="element-46">
                <tr className="bg-brand-purple text-brand-white" data-id="element-47">
                  <th className="py-[14px] px-5 text-left font-semibold" data-id="element-48">
                    ✅ Incluido
                  </th>
                  <th className="py-[14px] px-5 text-left font-semibold" data-id="element-49">
                    Valor
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-50">
                {[{
                name: 'Guía Digital Ruta USA 360 (PDF completo)',
                value: '$97'
              }, {
                name: 'Checklist paso a paso del proceso',
                value: '$27'
              }, {
                name: 'Lista de errores reales que debes evitar',
                value: '$27'
              }, {
                name: 'Requisitos reales (lo que nadie te dice)',
                value: '$20'
              }, {
                name: 'Acceso inmediato + descarga directa',
                value: 'Incluido'
              }].map((item, i) => <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-brand-grayBg'} data-id="element-51">
                    <td className="py-[14px] px-5 border-b border-brand-border text-[0.97rem]" data-id="element-52">
                      {item.name}
                    </td>
                    <td className="py-[14px] px-5 border-b border-brand-border text-[0.97rem] text-brand-purple font-bold" data-id="element-53">
                      {item.value}
                    </td>
                  </tr>)}
                <tr className="bg-brand-purple text-brand-white font-bold text-[1rem]" data-id="element-54">
                  <td className="py-[14px] px-5 border-b border-brand-border" data-id="element-55">
                    VALOR TOTAL
                  </td>
                  <td className="py-[14px] px-5 border-b border-brand-border" data-id="element-56">
                    $171
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="text-center mt-5" data-id="element-57">
            <p className="text-[1.1rem] line-through text-[#999] mb-1" data-id="element-58">
              Valor real: $171
            </p>
            <div className="font-serif text-[4rem] text-brand-purple font-black leading-none" data-id="element-59">
              $36
            </div>
            <p className="text-[0.9rem] text-[#666] mt-2" data-id="element-60">
              Pago único · Acceso inmediato · Sin suscripción
            </p>
          </div>

          <div className="text-center mt-9" data-id="element-61">
            <ButtonSecondary text="👉 Descargar Mi Guía Ahora — $36" href={checkoutUrl} data-id="element-62" />
            <p className="mt-[14px] text-[0.85rem] text-[#888]" data-id="element-63">
              Descarga directa · PDF · Sin complicaciones
            </p>
          </div>
        </FadeIn>
      </Section>

      <Section className="bg-brand-purple text-brand-white text-center" data-id="element-64">
        <FadeIn data-id="element-65">
          <span className="text-[4rem] mb-5 block" data-id="element-66">🛡️</span>
          <SectionLabel className="!text-brand-pink text-center" data-id="element-67">
            Sin riesgos
          </SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-brand-white mb-5 font-bold" data-id="element-68">
            Tu inversión está protegida.
          </h2>
          <p className="text-white/85 max-w-[540px] mx-auto mb-3 text-[1.05rem]" data-id="element-69">
            Si descargas la guía y sientes que no te dio claridad sobre el
            proceso de crear tu empresa en USA — escríbenos y lo resolvemos.
            Queremos que avances, no que desperdicies tu dinero.
          </p>
        </FadeIn>
      </Section>

      <Section className="bg-white" data-id="element-70">
        <FadeIn data-id="element-71">
          <SectionLabel data-id="element-72">Quién hay detrás</SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-brand-dark mb-5 font-bold" data-id="element-73">
            Creada por
            <br data-id="element-74" />
            <span className="text-brand-purple" data-id="element-75">@inkovacreation</span>
          </h2>

          <div className="flex flex-col sm:flex-row gap-7 items-start bg-brand-grayBg rounded-[20px] p-9 mt-7 border-l-[6px] border-brand-purple" data-id="element-76">
            <div className="w-[90px] h-[90px] rounded-full bg-brand-purple flex items-center justify-center text-[2.5rem] shrink-0" data-id="element-77">
              🏢
            </div>
            <div data-id="element-78">
              <h3 className="font-serif text-[1.4rem] text-brand-purple mb-[10px] font-bold" data-id="element-79">
                Inkova LLC
              </h3>
              <p className="text-[0.97rem] mb-2" data-id="element-80">
                En Inkova hemos acompañado a decenas de emprendedores latinos a
                crear su empresa en USA con orden, estructura y presencia
                digital — sin perderse en el camino.
              </p>
              <p className="text-[0.97rem] mb-2" data-id="element-81">
                Esta guía es el destilado de todo ese proceso, para que tú
                puedas avanzar por tu cuenta con la misma claridad que tienen
                nuestros clientes de consultoría.
              </p>
              <p className="text-brand-purple font-semibold text-[0.97rem]" data-id="element-82">
                ¿Prefieres hacerlo con acompañamiento? Con gusto te ayudamos a
                completar todo el proceso correctamente.
              </p>
            </div>
          </div>
        </FadeIn>
      </Section>

      <section className="bg-brand-purple text-brand-white text-center py-[100px] px-6" data-id="element-83">
        <FadeIn className="max-w-[800px] mx-auto" data-id="element-84">
          <h2 className="font-serif text-[clamp(2rem,5vw,3.2rem)] leading-[1.2] text-brand-white max-w-[680px] mx-auto mb-5 font-bold" data-id="element-85">
            Cada día que pasa
            <br data-id="element-86" />
            <span className="text-brand-pink" data-id="element-87">tu competencia avanza.</span>
          </h2>
          <p className="text-white/80 max-w-[480px] mx-auto mb-10 text-[1.05rem]" data-id="element-88">
            Tu idea merece una empresa real detrás. Ruta USA 360 te da el mapa.
            Tú pones la acción.
          </p>

          <ButtonPrimary text="👉 Descargar Mi Guía — $36" href={checkoutUrl} data-id="element-89" />

          <a href="https://wa.me/TUNUMERO" className="block mt-6 text-white/70 text-[0.95rem] no-underline hover:text-brand-pink transition-colors" data-id="element-90">
            ¿Tienes dudas? Escríbenos por WhatsApp →
          </a>
        </FadeIn>
      </section>
    </>;
};